import "./MessageComposer.css";
import "./MessagingButtons.css";
import {
  CHANNEL_OPTIONS,
  CHANNEL_UNAVAILABLE_NOTE,
  ComposeState,
  MessageTemplate,
  MESSAGE_TYPE_LABELS,
  normalizeComposeChannel,
} from "../../../models/MessageModels";
import MessageBodyEditor from "./MessageBodyEditor";

interface MessageComposerProps {
  compose: ComposeState;
  templates: MessageTemplate[];
  orgName: string;
  previewClient: { fullName: string; phone: string } | null;
  selectedCount: number;
  sending: boolean;
  showTitle?: boolean;
  onChange: (next: ComposeState) => void;
  onSend: () => void;
  onCreateCampaign: () => void;
}

const MessageComposer = ({
  compose,
  templates,
  orgName,
  previewClient,
  selectedCount,
  sending,
  showTitle = true,
  onChange,
  onSend,
  onCreateCampaign,
}: MessageComposerProps) => {
  const bodyValue = compose.body;
  const channel = normalizeComposeChannel(compose.channel);
  const canSend =
    selectedCount > 0 && bodyValue.trim().length > 0 && !sending;

  return (
    <div className="msg-composer">
      {showTitle && (
        <h3 className="msg-composer__title">Compose message</h3>
      )}

      <label className="msg-composer__field">
        <span className="msg-composer__label">Channel</span>
        <select
          value={String(channel)}
          onChange={(e) =>
            onChange({ ...compose, channel: Number(e.target.value) })
          }
        >
          {CHANNEL_OPTIONS.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
      </label>

      <label className="msg-composer__field">
        <span className="msg-composer__label">Message type</span>
        <select
          value={String(compose.messageType)}
          onChange={(e) =>
            onChange({ ...compose, messageType: Number(e.target.value) })
          }
        >
          {Object.entries(MESSAGE_TYPE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </label>

      <MessageBodyEditor
        compose={compose}
        templates={templates}
        orgName={orgName}
        previewClient={previewClient}
        onChange={onChange}
      />

      <div className="msg-composer__actions">
        <button
          className="msg-btn msg-btn--primary"
          disabled={!canSend}
          title={
            selectedCount === 0
              ? "Select at least one client first"
              : "Send to the selected clients"
          }
          onClick={onSend}
        >
          {sending
            ? "Sending…"
            : selectedCount === 1
              ? "Send to selected (1)"
              : `Send to selected (${selectedCount})`}
        </button>
        <button
          className="msg-btn msg-btn--secondary"
          disabled={selectedCount === 0 || sending}
          onClick={onCreateCampaign}
        >
          Create campaign
        </button>
      </div>

      <p className="msg-composer__note">
        <strong>Sent</strong> = message prepared and accepted. True delivery
        reports need provider integration later. When message type is{" "}
        <em>Follow-up</em>, sending marks the related follow-up as Contacted.{" "}
        {CHANNEL_UNAVAILABLE_NOTE}
      </p>
    </div>
  );
};

export default MessageComposer;